/*
* TODO: Rename to adalia_me_tranche_selection (already used in production, needs migration)
* 
* Disbursement component specific for Adalia M&E. 
* 
* Project can be passed as a prop, but if not, this component expects the document to contain an element with an id report-container 
* and that element have a data-attribute called project-id.
* 
* Loads the planned tranches as options
*/
import React from 'react';
import { fetchJson } from '../../../helpers/fetch.js';

import {
  Mode,
  DataType,
} from "../common.jsx";
import Setting from './setting.jsx';

import Resolver from '../component_resolver.jsx'
import DropdownSelectionWithAsyncOptions from './dropdown_selection_with_async_options.jsx';

import { monitoring_list_payments_for_selection_json_path } from '~/routes';

const PAYMENT_STATUS = {
  PLANNED: 'planned'
}

const fetchPayments = (project_id, selected, handlingEnabled, cb) => {
  fetchJson(monitoring_list_payments_for_selection_json_path({ project_id: project_id })).then(
    (res) => {
      cb(res.map(p => ({ ...p, disabled: handlingEnabled && p.value != selected && PAYMENT_STATUS.PLANNED != p.status })));
    }
  )
}

export default class AdaliaMEDisbursement extends DropdownSelectionWithAsyncOptions {
  static get CATEGORY() {
    return 'question';
  }

  // Can be dependent on the contract selection
  static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = "") {
    let names = [];
    if (content.name) {
      names.push(repeatedFieldScope + "[" + content.name + "]");
    }
    let dependentOptions = content.dependentOptions ? ['[' + content.dependentOptions + ']'] : [];
    return [...dependentOptions, ...names];
  }

  static get SETTINGS_DUMMY_DATA() {
    return [
      { value: 1, label: 'Example 1', disbursement_identifier: 1, payment_contract_id: 1, payment_type: 'Payment' },
      { value: 2, label: 'Example 2', disbursement_identifier: 1, payment_contract_id: 1, payment_type: 'Grants' },
      { value: 3, label: 'Example 3', disbursement_identifier: 2, payment_contract_id: 2, payment_type: 'Payment' },
      { value: 4, label: 'Example 4', disbursement_identifier: 2, payment_contract_id: 2, payment_type: 'Grants' },
      { value: 5, label: 'Example 5', disbursement_identifier: 3, payment_contract_id: 2, payment_type: 'Payment' },
      { value: 6, label: 'Example 6', disbursement_identifier: 3, payment_contract_id: 2, payment_type: 'Grants' }
    ];
}

  static get TYPE() {
    // Tranche selection
    return 'adalia_me_disbursement';
  }

  static icon() {
    return <i className="fa fa-money"></i>;
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_disbursement_default_label',
      description: 'field_disbursement_default_description',
      help: null,
      blankOptionLabel: 'select_blank_option_default'
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
        name: 'disbursement',
        reportKey: '',
        dataType: DataType.INTEGER,
        includeBlank: true
    });
  }

  static dropAllowed(dropArea, droppedContent, components, isNested) {
    if (!super.dropAllowed(dropArea, droppedContent, components, isNested)) {
      return false;
    };

    if (components != undefined) {
      for (var i = 0; i < components.length; i++) {
        const comp = components[i];
        if (
          [comp, ...Resolver.componentClass(comp.type).nestedComponents(components[i])].find(
            (c) => c.type === "adalia_me_tranche_collection"
          )
        ) {
          alert(I18n.t('alert_tranche_and_disbursement_in_same_form', {scope: 'fe'}));
          return false;
        }
      }
    }

    return true;
  }

  renderSettings() {
    return <>
      <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
      <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField
        name="reportKey"
        label={I18n.t('field_report_key', {scope: 'fe'})}
        value={this.props.content.reportKey}
        description={I18n.t('field_report_key_description', {scope: 'fe'})}
        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
      />
    </>
  }

  loadPayments = () => {
    let project_id = this.props.project?.id || this.props.projectId || jQuery('#report-container').data('project-id');

    fetchPayments(
      project_id, 
      this.getAnswer(), 
       this.props.handleDisbursement,
      (res) => {
        if (res) {
          this.setState({
            payments: res,
            loading: false,
            mappedToOptions: false,
          })
        }
    });
  }

  componentDidMount() {
    super.componentDidMount();

    let project_id = this.props.project?.id || this.props.projectId || jQuery('#report-container').data('project-id');
    if (!project_id || [Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
      this.setState({ payments: this.constructor.SETTINGS_DUMMY_DATA, loading: false });
    } else {
      this.loadPayments();
    }
  }

  onChange = (value) => {
    // Selecting one with disbursement identifier, select all others as well
    if (this.props.content.allowMultiple && value && value.length > 0) {
      const allOpts = Object.values(this.state.options).flat();
      const selectedIdentifier = allOpts.find(opt => opt.value == value[0]).disbursement_identifier;

      if (selectedIdentifier) {
        const multiValue = allOpts.filter(opt => opt.disbursement_identifier == selectedIdentifier).map(opt => opt.value)
        this.updateAnswer(multiValue);
        return;
      }
    }
    
    this.updateAnswer(value);
  }

  updateAnswer(value) {
    super.updateAnswer(value);
    // Additionally update the types for type component
    if (this.props.updateAnswerCallback && Object.values(this.state.options).flat().length > 0) {
      const hasRepeatedFieldScope = !!this.props.repeatedFieldScope;
        if (this.props.content.typeName) {
          this.props.updateAnswerCallback(
            `${this.props.repeatedFieldScope || ""}${hasRepeatedFieldScope ? "[" : ""}${
              this.props.content.typeName
            }${hasRepeatedFieldScope ? "]" : ""}`,
            [...new Set(this.getSelectedOptions(value).map((o) => o.payment_type))]
          );
        }
        if (this.props.content.disbursementName) {
          this.props.updateAnswerCallback(
            `${this.props.repeatedFieldScope || ""}${hasRepeatedFieldScope ? "[" : ""}${
              this.props.content.disbursementName
            }${hasRepeatedFieldScope ? "]" : ""}`,
            [...new Set(this.getSelectedOptions(value).map((o) => o.disbursement_identifier))][0] || ""
          );
        }
    }
  }

  formatOptionLabel = (option, meta) => {
    if (this.props.autoSelectNextTranche) {
      return <div>{option.payment_type}</div>
    }
    return <p>{option.label}</p>
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate();
    
    if (this.state.loading || [Mode.EDIT, Mode.SETTINGS, Mode.TOOLBAR_ITEM].includes(this.props.mode)) {
      return;
    }

    if (
      this.props.content.dependentOptions && 
      this.props.answers != prevProps.answers &&
      JSON.stringify(this.props.answers[this.props.content.dependentOptions]) != JSON.stringify(prevProps.answers[this.props.content.dependentOptions])
    ) {
      // Reset selection on change of contract
      this.setState({selected: []})
    }

    if (
      this.props.mode != Mode.VIEW &&
      this.props.content.dependentOptions && 
      (
        (!this.state.options || !this.state.mappedToOptions) || 
        prevProps.answers[this.props.content.dependentOptions] != this.props.answers[this.props.content.dependentOptions]
      )
    ){
      const selectedOption = this.state.payments.find(p => p.value == this.getSelected()[0]);
      // Filter allOpts by dependent
      this.setState({
        mappedToOptions: true,
        options: 
          // Allow selecting only from same contract. Only allow selecting ones with same disbursement number
          this.state.payments.filter(
            (opt, index) => { 
              return opt.payment_contract_id == (this.props.answers[this.props.content.dependentOptions] || {})[0] &&
              (!this.props.autoSelectNextTranche || this.state.payments.findIndex(p => p.payment_type == opt.payment_type) >= index )
            }
          ).map(opt => ({...opt, disabled: opt.disabled || (selectedOption && opt.disbursement_identifier != selectedOption.disbursement_identifier)}))
        ,
      })
    } else if (this.state.options.length == 0) {
      // Otherwise set all options as available
      this.setState({
        mappedToOptions: true,
        options: this.state.payments,
      })
    }

  }
}